import PropTypes from "prop-types";
import { CDSThemeProvider } from "@ciscodesignsystems/cds-react-theme-provider";

const AppThemeProvider = ({ children, theme = "light" }) => (
  <CDSThemeProvider theme={theme}>{children}</CDSThemeProvider>
);

AppThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.string,
};

export default AppThemeProvider;
